import React from 'react';

const BudgetGridLocationBreakup = ({viewData}) => (
    <div className="saras-cell" style={{width: 250}}>
        <ul className="uiSearchSubList uiBudgetLocationBreakup" style={{width: 250, minWidth: 250}}>
            {Object.values(viewData.childRows || {}).map(row => (
                <li key={row.rowValues.sheetId.val}>
                    <span style={{display: 'inline-block', width: 70, verticalAlign: 'top', textAlign: 'center'}}>{row.rowValues.sheetQty.valF}</span>
                    <span style={{display: 'inline-block', width: 80, verticalAlign: 'top', textAlign: 'left'}}>{row.rowValues.location.valF}</span>
                    <span title={row.rowValues.comment.valF} style={{display: 'inline-block', width: 100, verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{row.rowValues.comment.valF}</span>
                </li>
            ))}
        </ul>
    </div>
);

export default BudgetGridLocationBreakup;
